import { API, graphqlOperation } from 'aws-amplify';
import { createTransactionWithSpecificTimev2 } from '../../../graphql';
import type { CreateTransactionWithSpecificTimev2MutationVariables, CreateTransactionWithSpecificTimev2Mutation } from '../../../graphql';

export const createTransactionWithSpecificTime = async (input: CreateTransactionWithSpecificTimev2MutationVariables): Promise<CreateTransactionWithSpecificTimev2Mutation> => {
  return await API.graphql(graphqlOperation(createTransactionWithSpecificTimev2, input)) as CreateTransactionWithSpecificTimev2Mutation;
};
